export default {
  "content": "<path fill=\"none\" d=\"M-1-1h88v88H-1z\"/><circle cx=\"43\" cy=\"43\" r=\"40\" fill=\"#EA3917\"/><path fill=\"#FFF\" d=\"M58.472 30.645l-3.117-3.117L43 39.884 30.645 27.528l-3.117 3.117L39.884 43 27.528 55.355l3.117 3.117L43 46.116l12.355 12.356 3.117-3.117L46.117 43l12.355-12.355z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 86 86"
  }
};